module.exports = __webpack_public_path__ + "img/F-day_btn_music-on.7b65a48a.png";